module.exports = __webpack_public_path__ + "static/media/img16.baf17c7d.JPG";